import * as React from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import * as rsuite from "rsuite";
import "rsuite/dist/rsuite-rtl.min.css";
import { trackPromise } from "react-promise-tracker";
import * as BiIcon from "react-icons/bi";
import * as ReactDOM from 'react-router-dom';
import ArrowLeftLineIcon from "@rsuite/icons/ArrowLeftLine";
import AngleLeftIcon from "@rsuite/icons/legacy/AngleLeft";
import AngleRightIcon from "@rsuite/icons/legacy/AngleRight";
import { Modal } from "react-bootstrap";
import axios from "axios";
import * as General from "../Business/General/General.js";
const NavToggle = ({ expand, onChange }) => {
  return (
    <rsuite.Navbar appearance="subtle" className="nav-toggle">
      <rsuite.Nav pullRight>
        <rsuite.Nav.Item
          className="SidebarMenuItem"
          onClick={onChange}
          style={{ width: 56, textAlign: "center" }}
        >
          {expand ? <AngleLeftIcon /> : <AngleRightIcon />}
        </rsuite.Nav.Item>
      </rsuite.Nav>
    </rsuite.Navbar>
  );
};


const PrivateLayout = ({ title, children }) => {
  //#region Const

  const [expand, setExpand] = React.useState(false);
  const [UserName, setUserName] = React.useState(localStorage.getItem("UserName"));
  let navigate = ReactDOM.useNavigate();
  const ref = React.useRef();

  const toaster = rsuite.useToaster();

  const [PassModal, setPassModal] = React.useState(false);
  const [NewPass, setNewPass] = React.useState("");
  const [OldPass, setOldPass] = React.useState("");
  const [RepeatPass, setRepeatPass] = React.useState("");


  //#endregion

  //#region OnChange
  const OldPass_Change = (e) => {
    setOldPass(e);
  };
  const NewPass_Change = (e) => {
    setNewPass(e);
  };
  const RepeatPass_Change = (e) => {
    setRepeatPass(e);
  };

  //#endregion


  const ChangePass = () => {
    setPassModal(true);
  };
  const SavePass = () => {
    var data = "";
    data = JSON.stringify({
      Password: OldPass,
      NewPass: NewPass,
      RepeatNewPass: RepeatPass,
      Log: { UserName: UserName },
    });
    var requestOption = {
      data: data,
      method: "Post",
      withCredentials: true,

      url: General.ApiRoute() + "/User/UpdatePassword",
      headers: {
        "content-type": "application/json",
        Apikey: General.APIKey(),
      },
    };
    trackPromise(
      axios(requestOption).then(function (result) {
        if (result.data == "OK") {
          setPassModal(false);
          toaster.push(
            General.SuccessMessage("success", General.SuccessMessage("ذخیره شده است")), "topCenter"
          );
        } else if (result.data == "NotOK")
          toaster.push(
            General.ShowMessage("error", General.ErrorMessage("کلمه عبور جدید و تکرار آن با هم تطابق ندارند")), "topCenter"
          );
        else if (result.data == "NotPass")
          toaster.push(General.ShowMessage("error", General.ErrorMessage("کلمه عبور فعلی اشتباه می باشد")), "topCenter"
          );
        else
          toaster.push(General.ShowMessage("error", General.ErrorMessage(result.data)), "topCenter"
          );
      })
    );
  };

  const ProfilePopover = React.forwardRef(({ onSelect, ...rest }, ref) => (
    <rsuite.Popover ref={ref} {...rest} full>
      <rsuite.Dropdown.Menu onSelect={onSelect}>
        <rsuite.Dropdown.Item onClick={ChangePass}>
          تغییر کلمه عبور
        </rsuite.Dropdown.Item>
        <rsuite.Dropdown.Item eventKey={2} onClick={LogOut}>
          خـــروج
        </rsuite.Dropdown.Item>
      </rsuite.Dropdown.Menu>
    </rsuite.Popover>
  ));

  const LogOut = () => {
    var requestOptions = {
      method: "Post",
      credentials: "include",
    };

    trackPromise(
      fetch(General.ApiRoute() + "/User/Logout", requestOptions)
        .then((result) => {
          localStorage.clear();
          navigate("/");
        })
        .catch((error) => { })
    );
  };



  return (
    <>
      <rsuite.Container >
        <rsuite.Sidebar
          width={expand ? 260 : 0}
          collapsible
          className="FarmAsan-success h-100vh overflow-y LeftRound"
          appearance="inverse"
        >
          <rsuite.Sidenav.Header>
            <div className="text-center p-1">
            </div>
          </rsuite.Sidenav.Header>
          <rsuite.Sidenav
            className="bg_SideBar"
            expanded={expand}
            appearance="subtle"
          >
            <rsuite.Sidenav.Body >
              <rsuite.Nav>

                <rsuite.Nav.Menu eventKey="0" trigger="hover" title="کـــاربران" icon={<ArrowLeftLineIcon />} placement="rightStart" >
                  <ReactDOM.Link to="/Role">
                    <rsuite.Nav.Item className="SidebarMenuItem" href="/Role" eventKey="0-1" >سطوح دسترسی</rsuite.Nav.Item>
                  </ReactDOM.Link>
                  <ReactDOM.Link to="/User">
                    <rsuite.Nav.Item className="SidebarMenuItem" href="/User" eventKey="0-2"> مدیریت کاربران </rsuite.Nav.Item>
                  </ReactDOM.Link>
                  <ReactDOM.Link to="/UserConfig">
                    <rsuite.Nav.Item className="SidebarMenuItem" href="/UserConfig" eventKey="0-2"> تنظیمات سیستم </rsuite.Nav.Item>
                  </ReactDOM.Link>
                </rsuite.Nav.Menu>

                <rsuite.Nav.Menu eventKey="1" trigger="hover" title="اطلاعات پابه" icon={<ArrowLeftLineIcon />} placement="rightStart" >
                  <ReactDOM.Link to="/FiscalYear">
                    <rsuite.Nav.Item className="SidebarMenuItem" href="/FiscalYear" eventKey="1-1" >سال مالی </rsuite.Nav.Item>
                  </ReactDOM.Link>
                  <ReactDOM.Link to="/StoreRoom">
                    <rsuite.Nav.Item className="SidebarMenuItem" href="/StoreRoom" eventKey="1-2" >تعریف انبار</rsuite.Nav.Item>
                  </ReactDOM.Link>
                  <ReactDOM.Link to="/ProvinceCity">
                    <rsuite.Nav.Item className="SidebarMenuItem" href="/ProvinceCity" eventKey="1-3" >استان/ شهر </rsuite.Nav.Item>
                  </ReactDOM.Link>
                  <ReactDOM.Link to="/ProductGroup">
                    <rsuite.Nav.Item className="SidebarMenuItem" href="/ProductGroup" eventKey="1-4" >گروه بندی محصولات </rsuite.Nav.Item>
                  </ReactDOM.Link>
                  <ReactDOM.Link to="/Brand">
                    <rsuite.Nav.Item className="SidebarMenuItem" href="/Brand" eventKey="1-5" >  برند محصولات </rsuite.Nav.Item>
                  </ReactDOM.Link>
                  <ReactDOM.Link to="/Product">
                    <rsuite.Nav.Item className="SidebarMenuItem" href="/Product" eventKey="1-6" >  محصولات </rsuite.Nav.Item>
                  </ReactDOM.Link>
                  <ReactDOM.Link to="/Fund">
                    <rsuite.Nav.Item className="SidebarMenuItem" href="/Fund" eventKey="1-7" >  صندوق </rsuite.Nav.Item>
                  </ReactDOM.Link>

                  <ReactDOM.Link to="/Bank">
                    <rsuite.Nav.Item className="SidebarMenuItem" href="/Bank" eventKey="1-8" >  تعریف بانک و حساب بانکی</rsuite.Nav.Item>
                  </ReactDOM.Link>
                  <ReactDOM.Link to="/AccountDetail">
                    <rsuite.Nav.Item className="SidebarMenuItem" href="/AccountDetail" eventKey="1-9" > تعریف گروه حساب/حساب کل/حساب معین </rsuite.Nav.Item>
                  </ReactDOM.Link>
                  <ReactDOM.Link to="/DocType">
                    <rsuite.Nav.Item className="SidebarMenuItem" href="/DocType" eventKey="1-10" > انواع سند حسابداری </rsuite.Nav.Item>
                  </ReactDOM.Link>
                  <ReactDOM.Link to="/DOCSettings">
                    <rsuite.Nav.Item className="SidebarMenuItem" href="/DOCSettings" eventKey="1-11" > تنظیمات صدور سند </rsuite.Nav.Item>
                  </ReactDOM.Link>
                </rsuite.Nav.Menu>


                <rsuite.Nav.Menu eventKey="5" trigger="hover" title="خرید و فروش" icon={<ArrowLeftLineIcon />} placement="rightStart" >


                  <ReactDOM.Link to="/BuyOrder">
                    <rsuite.Nav.Item className="SidebarMenuItem" href="/BuyOrder" eventKey="5-2"> فاکتور خرید  </rsuite.Nav.Item>
                  </ReactDOM.Link>
                  <ReactDOM.Link to="/PreFactor">
                    <rsuite.Nav.Item className="SidebarMenuItem" href="/PreFactor" eventKey="5-3"> پیش فاکتور   </rsuite.Nav.Item>
                  </ReactDOM.Link>
                  <ReactDOM.Link to="/Factor">
                    <rsuite.Nav.Item className="SidebarMenuItem" href="/Factor" eventKey="5-4"> فاکتور فروش  </rsuite.Nav.Item>
                  </ReactDOM.Link>
                </rsuite.Nav.Menu>

                <rsuite.Nav.Menu eventKey="8" trigger="hover" title="حسابداری" icon={<ArrowLeftLineIcon />} placement="rightStart" >
                  <ReactDOM.Link to="/ProductPricePercent">
                    <rsuite.Nav.Item className="SidebarMenuItem" href="/ProductPricePercent" eventKey="5-1">  به روز رسانی درصدی قیمت   </rsuite.Nav.Item>
                  </ReactDOM.Link>
                  <ReactDOM.Link to="/ProductPrice">
                    <rsuite.Nav.Item className="SidebarMenuItem" href="/ProductPrice" eventKey="5-1">  به روز رسانی ریالی قیمت    </rsuite.Nav.Item>
                  </ReactDOM.Link>
                  <ReactDOM.Link to="/DocIndex">
                    <rsuite.Nav.Item className="SidebarMenuItem" href="/DocIndex" eventKey="8-1"> لیست اسناد حسابداری </rsuite.Nav.Item>
                  </ReactDOM.Link>
                  <ReactDOM.Link to="/InsertDoc">
                    <rsuite.Nav.Item className="SidebarMenuItem" href="/InsertDoc" eventKey="8-2">صدور سند حسابداری  </rsuite.Nav.Item>
                  </ReactDOM.Link>

                </rsuite.Nav.Menu>
                <rsuite.Nav.Menu eventKey="9" trigger="hover" title="خزانه" icon={<ArrowLeftLineIcon />} placement="rightStart" >


                  <ReactDOM.Link to="/PaymentReceived">
                    <rsuite.Nav.Item className="SidebarMenuItem" href="/PaymentReceived" eventKey="9-1"> لیست رسید پرداخت</rsuite.Nav.Item>
                  </ReactDOM.Link>
                  <ReactDOM.Link to="/InsertPaymentReceived" onClick={() => {
                    localStorage.setItem("PaymentReceivedId", General.GuidEmpty())
                  }}>
                    <rsuite.Nav.Item className="SidebarMenuItem" href="/InsertPaymentReceived" eventKey="9-2"> صدور رسید پرداخت</rsuite.Nav.Item>
                  </ReactDOM.Link>
                  <ReactDOM.Link to="/ReciptReceived">
                    <rsuite.Nav.Item className="SidebarMenuItem" href="/ReciptReceived" eventKey="9-3">  لیست رسید دریافت  </rsuite.Nav.Item>
                  </ReactDOM.Link>
                  <ReactDOM.Link to="/InsertPaymentReceived" style={{ pointerEvents: "none", opacity: 0.5, userSelect: "none" }}
                    onClick={() => {
                      localStorage.setItem("RecieptReceivedId", General.GuidEmpty())
                    }}>
                    <rsuite.Nav.Item className="SidebarMenuItem" href="/InsertPaymentReceived" eventKey="9-2"> صدور رسید دریافت</rsuite.Nav.Item>
                  </ReactDOM.Link>
                </rsuite.Nav.Menu>

                <rsuite.Nav.Menu eventKey="6" trigger="hover" title="انبار" icon={<ArrowLeftLineIcon />} placement="rightStart" >

                  <ReactDOM.Link to="/FirstPeriodReciept">
                    <rsuite.Nav.Item className="SidebarMenuItem" href="/FirstPeriodReciept" eventKey="6-1" >رسید اول دوره </rsuite.Nav.Item>
                  </ReactDOM.Link>
                  <ReactDOM.Link to="/Reciept">
                    <rsuite.Nav.Item className="SidebarMenuItem" href="/Reciept" eventKey="6-2" >رسید ورود به انبار </rsuite.Nav.Item>
                  </ReactDOM.Link>
                  <ReactDOM.Link to="/SaleTransfer" > {/* style={{ pointerEvents: "none", opacity: 0.5 , userSelect: "none" }} */}
                    <rsuite.Nav.Item className="SidebarMenuItem" href="/SaleTransfer" eventKey="6-3" >حواله فروش </rsuite.Nav.Item>
                  </ReactDOM.Link>
                  <ReactDOM.Link to="/BasketTransfer" >
                    <rsuite.Nav.Item className="SidebarMenuItem" href="/BasketTransfer" eventKey="6-3" >حواله موقت (سایت) </rsuite.Nav.Item>
                  </ReactDOM.Link>
                  <ReactDOM.Link to="/Transfer" style={{ pointerEvents: "none", opacity: 0.5, userSelect: "none" }} > {/* style={{ pointerEvents: "none", opacity: 0.5 , userSelect: "none" }} */}
                    <rsuite.Nav.Item className="SidebarMenuItem" href="/Transfer" eventKey="6-4" >حواله کسری انبار </rsuite.Nav.Item>
                  </ReactDOM.Link>
                  <ReactDOM.Link to="/Transfer" style={{ pointerEvents: "none", opacity: 0.5, userSelect: "none" }} > {/* style={{ pointerEvents: "none", opacity: 0.5 , userSelect: "none" }} */}
                    <rsuite.Nav.Item className="SidebarMenuItem" href="/Transfer" eventKey="6-5" >حواله انتقال بین انبار  </rsuite.Nav.Item>
                  </ReactDOM.Link>
                  <ReactDOM.Link to="/Transfer" style={{ pointerEvents: "none", opacity: 0.5, userSelect: "none" }} > {/* style={{ pointerEvents: "none", opacity: 0.5 , userSelect: "none" }} */}
                    <rsuite.Nav.Item className="SidebarMenuItem" href="/Transfer" eventKey="6-6" >حواله برگشت از خرید  </rsuite.Nav.Item>
                  </ReactDOM.Link>
                  <ReactDOM.Link to="/Transfer" style={{ pointerEvents: "none", opacity: 0.5, userSelect: "none" }} > {/* style={{ pointerEvents: "none", opacity: 0.5 , userSelect: "none" }} */}
                    <rsuite.Nav.Item className="SidebarMenuItem" href="/Transfer" eventKey="6-7" >حواله امانی  </rsuite.Nav.Item>
                  </ReactDOM.Link>

                  <ReactDOM.Link to="/InventoryCounting">
                    <rsuite.Nav.Item className="SidebarMenuItem" href="/InventoryCounting" eventKey="6-8" > انبار گردانی </rsuite.Nav.Item>
                  </ReactDOM.Link>
                </rsuite.Nav.Menu>

                <rsuite.Nav.Menu eventKey="7" trigger="hover" title="وب سایت" icon={<ArrowLeftLineIcon />} placement="rightStart" >

                  <ReactDOM.Link to="/SuggestionProduct">
                    <rsuite.Nav.Item className="SidebarMenuItem" href="/SuggestionProduct" eventKey="7-1" >  محصولات جهت پیشنهاد موتور برق </rsuite.Nav.Item>
                  </ReactDOM.Link>
                  <ReactDOM.Link to="/Discount">
                    <rsuite.Nav.Item className="SidebarMenuItem" href="/Discount" eventKey="7-2"> بسته تخفیفات   </rsuite.Nav.Item>
                  </ReactDOM.Link>
                  <ReactDOM.Link to="/SalesSituation">
                    <rsuite.Nav.Item className="SidebarMenuItem" href="/SalesSituation" eventKey="7-3"> وضعیت فروش</rsuite.Nav.Item>
                  </ReactDOM.Link>
                  <ReactDOM.Link to="/Basket">
                    <rsuite.Nav.Item className="SidebarMenuItem" href="/Basket" eventKey="7-4"> سبد خرید </rsuite.Nav.Item>
                  </ReactDOM.Link>
                </rsuite.Nav.Menu>


                <rsuite.Nav.Menu eventKey="4" trigger="hover" title=" گزارشات" icon={<ArrowLeftLineIcon />} placement="rightStart" >
                  <ReactDOM.Link to="/CardexCountReport">
                    <rsuite.Nav.Item className="SidebarMenuItem" href="/CardexCountReport" eventKey="4-1" >کاردکس کالا (تعدادی)  </rsuite.Nav.Item>
                  </ReactDOM.Link>
                  <ReactDOM.Link to="/StorRoomInventoryExist">
                    <rsuite.Nav.Item className="SidebarMenuItem" href="/StorRoomInventoryExist" eventKey="4-1" >گزارش موجودی انبار  </rsuite.Nav.Item>
                  </ReactDOM.Link>
                  <ReactDOM.Link to="/GeneralLedgerRepor">
                    <rsuite.Nav.Item className="SidebarMenuItem" href="/GeneralLedgerRepor" eventKey="4-2" >دفتر کل </rsuite.Nav.Item>
                  </ReactDOM.Link>
                  <ReactDOM.Link to="/ControlReport">
                    <rsuite.Nav.Item className="SidebarMenuItem" href="/ControlReport" eventKey="4-3" >دفتر معین </rsuite.Nav.Item>
                  </ReactDOM.Link>
                  <ReactDOM.Link to="/DayReport">
                    <rsuite.Nav.Item className="SidebarMenuItem" href="/DayReport" eventKey="4-4" >دفتر روزانه </rsuite.Nav.Item>
                  </ReactDOM.Link>
                  <ReactDOM.Link to="/AccountStatementReport">
                    <rsuite.Nav.Item className="SidebarMenuItem" href="/AccountStatementReport" eventKey="4-5" >گزارش ریز حساب ها  </rsuite.Nav.Item>
                  </ReactDOM.Link>
                </rsuite.Nav.Menu>
              </rsuite.Nav>
            </rsuite.Sidenav.Body>
          </rsuite.Sidenav>
        </rsuite.Sidebar>

        <rsuite.Content >
          <rsuite.Grid fluid className="bg-white mb-0">
            <rsuite.Row className="pt-2 ps-3 pe-3 ">
              <rsuite.Col
                xxl={16}
                xl={16}
                lg={16}
                md={16}
                sm={16}
                xs={16}
              >
                {!expand ? (
                  <BiIcon.BiMenu
                    className="Cursor"
                    size={21}
                    onClick={() => setExpand(!expand)}
                  />
                ) : (
                  <BiIcon.BiMinus
                    className="Cursor"
                    size={21}
                    onClick={() => setExpand(!expand)}
                  />
                )}
                <b className="Font14 pe-2">&nbsp;&nbsp;&nbsp;{title}</b>
              </rsuite.Col>
              <rsuite.Col
                xxl={8}
                xl={8}
                lg={8}
                md={8}
                sm={8}
                xs={8}
                className="text-left" >
                <rsuite.Whisper
                  placement="bottomEnd"
                  controlId="control-id-with-dropdown"
                  trigger="click"
                  ref={ref}
                  speaker={<ProfilePopover />}
                >
                  <span className="p-2 Cursor">
                    <b>
                      <BiIcon.BiUserCircle size={21} /> &nbsp;
                      {localStorage.getItem("UserFullName")}
                    </b>
                  </span>
                </rsuite.Whisper>
              </rsuite.Col>
            </rsuite.Row>
            <rsuite.Row>
              <rsuite.Col
                xxl={24}
                xl={24}
                lg={24}
                md={24}
                sm={24}
                xs={24}
                className="h-95vh">
                {children}
              </rsuite.Col>
            </rsuite.Row>
          </rsuite.Grid>
        </rsuite.Content>
      </rsuite.Container>

      <Modal show={PassModal} onHide={() => setPassModal(false)} size="md">
        <Modal.Header closeButton>
          <Modal.Title>تغییر کلمه عبور</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <rsuite.Grid fluid>
            <rsuite.Row className="p-1">
              <rsuite.Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24}>
                <label>کلمه عبور فعلی</label>
                <rsuite.Whisper
                  trigger="focus"
                  speaker={<rsuite.Tooltip>الزامی می باشد</rsuite.Tooltip>}
                >
                  <rsuite.Input value={OldPass} onChange={OldPass_Change} />
                </rsuite.Whisper>
              </rsuite.Col>
              <rsuite.Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24}>
                <label>کلمه عبور جدید</label>
                <rsuite.Whisper
                  trigger="focus"
                  speaker={<rsuite.Tooltip>الزامی می باشد</rsuite.Tooltip>}
                >
                  <rsuite.Input value={NewPass} onChange={NewPass_Change} />
                </rsuite.Whisper>
              </rsuite.Col>
              <rsuite.Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24}>
                <label>تکرار کلمه عبور جدید</label>
                <rsuite.Whisper
                  trigger="focus"
                  speaker={<rsuite.Tooltip>الزامی می باشد</rsuite.Tooltip>}
                >
                  <rsuite.Input
                    value={RepeatPass}
                    onChange={RepeatPass_Change}
                  />
                </rsuite.Whisper>
              </rsuite.Col>
            </rsuite.Row>
          </rsuite.Grid>
        </Modal.Body>
        <Modal.Footer>
          <rsuite.Button appearance="primary" color="green" onClick={SavePass}>
            ذخیره
          </rsuite.Button>
          <rsuite.Button
            onClick={() => setPassModal(false)}
            appearance="subtle"
          >
            بستن
          </rsuite.Button>
        </Modal.Footer>
      </Modal>



    </>
  );
};

export default PrivateLayout;